import { render, staticRenderFns } from "./devicedeatil.vue?vue&type=template&id=12876618&scoped=true"
import script from "./devicedeatil.vue?vue&type=script&lang=js"
export * from "./devicedeatil.vue?vue&type=script&lang=js"
import style0 from "./devicedeatil.vue?vue&type=style&index=0&id=12876618&prod&scoped=true&lang=less"
import style1 from "./devicedeatil.vue?vue&type=style&index=1&id=12876618&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12876618",
  null
  
)

export default component.exports